import NavLink from "./nav-link";

export default NavLink;
